/**
 * Query string for GET /order/:id — matches UI language (i18n), not browser Accept-Language alone.
 * @param {string | undefined} i18nLanguage
 * @returns {string}
 */
export function buildOrderDetailLangQuery(i18nLanguage) {
  const lang = encodeURIComponent(String(i18nLanguage || 'en-us').toLowerCase().replace('_', '-'));
  return `lang=${lang}`;
}

/**
 * Append UI language query param for API routes that use getLanguageFromRequest.
 * @param {string} url
 * @param {string | undefined} i18nLanguage
 * @returns {string}
 */
export function appendLangQueryToUrl(url, i18nLanguage) {
  if (!url) {
    throw new Error('url is required to append language query');
  }
  const langQuery = buildOrderDetailLangQuery(i18nLanguage);
  return url.includes('?') ? `${url}&${langQuery}` : `${url}?${langQuery}`;
}
